export default __webpack_public_path__ + "static/media/ico_arrow_down_black.b0e53c68.svg";